import { render, staticRenderFns } from "./EmploymentTab.vue?vue&type=template&id=85354c60"
import script from "./EmploymentTab.vue?vue&type=script&lang=js"
export * from "./EmploymentTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports